import IDevice from "../models/devices/IDevice";
import ILAPSDetails from "../models/devices/ILAPSDetails";
import IErrorResponse from "../models/networking/IErrorResponse";
import networkService from "./networkService";

class DeviceService {

    async getDevice(deviceId: string) : Promise<IDevice> {
        const result = await networkService.get<IDevice>(`/devices/${deviceId}`);
        if (result.isSuccessful) {
            return result.data as IDevice;
        }
        
        const error = result.data as IErrorResponse;
        throw new Error(error.message);
    }
    
    async getDevices() : Promise<IDevice[]> {
        const result = await networkService.get<IDevice[]>("/devices");

        if (result.isSuccessful) {
            return result.status === 200
                ? result.data as IDevice[]
                : [];
        } else {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

    async getLAPS(deviceId: string) : Promise<ILAPSDetails[]> {
        const result = await networkService.get<ILAPSDetails[]>(`/devices/${deviceId}/laps`);
        if (result.isSuccessful) {
            return result.data as ILAPSDetails[];
        }
        
        const error = result.data as IErrorResponse;
        throw new Error(error.message);
    }
}

const deviceService = new DeviceService();
export default deviceService;